export default __webpack_public_path__ + "images/logoYahoo.63955296465fb80fbee5d8f42dca5f0f.svg"